module.exports = __webpack_public_path__ + "img/prev_active.d26ffacf.png";